export function isRecord<T>(value: T): value is T & Record<string, unknown> {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
